import React from 'react'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, BACK_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import { fetchDetails, getParsedDate, getDateString, scrollToTop } from './Api';
import { format } from 'date-fns';



export default function Page() {
    const { id } = useParams()

    const [page, setpage] = useState([])
    const [sessionspeaker, setsessionspeaker] = useState([])


    useEffect(() => {
        const fetchData = async ({ id }) => {
            const url = `${API_URL}/scheduledata/${id}`;
            const data = await fetchDetails(url);
            if (data) {
                setpage(data);
            }
            scrollToTop();
        };
        fetchData({ id });

    }, []);


    useEffect(() => {
        const fetchSessionSpeaker = async ({ id }) => {
            const url = `${API_URL}/sessionspeaker/${id}`;
            const data1 = await fetchDetails(url);
            if (data1) {
                setsessionspeaker(data1);
            }

        };
        fetchSessionSpeaker({ id });
        // console.log(sessionspeaker)
    }, [id]);

    const dataCount = sessionspeaker.length;

    const styles = {
        backgroundColor: "rgb(238, 236, 234)",
        // fontSize: props.fontSize,
        // fontWeight: props.bold ? 'bold' : 'normal'
    };


    return (
        <>
            {/* {dataCount} */}
            <main id="tg-main" className="tg-main tg-haslayout">

                <section className="tg-sectionspace tg-haslayout tg-bg" id="tg-about">
                    <div className="container">
                        <div className="row">
                            <div className="tg-aboutus">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                                    {/* {JSON.stringify(page)} */}

                                    {page.map(pag => (

                                        <div className="tg-sectionhead tg-textalignleft">
                                            <div className="tg-sectionheading">

                                                <h2>{pag.title}</h2>


                                            </div>
                                            {/* Day 2, 5 April 2023, 1315-1430 (IST) */}
                                            <div className="tg-description">
                                                <h3>
                                                    Day {pag.dayid}, Studio {pag.studioid}, {getDateString(pag.startdate)}, {getParsedDate(pag.startdate)} - {getParsedDate(pag.enddate)} Hrs

                                                    {/* {format(`${getDateString(pag.startdate)}`, 'dd M, yyyy')} */}
                                                </h3>

                                            </div>
                                            {pag.videourlstatus == 1 ?
                                                <div className="tg-description">
                                                    < iframe
                                                        title={pag.title}
                                                        width="560"
                                                        height="600"
                                                        src={pag.videourl}
                                                        frameBorder="0"
                                                        allow="autoplay; encrypted-media"
                                                        allowFullScreen
                                                        autoplay
                                                    />
                                                </div> : ''
                                            }
                                            <div className="tg-description">
                                                <div dangerouslySetInnerHTML={{ __html: pag.description }}></div>
                                            </div>

                                        </div>
                                    ))}


                                </div>

                            </div>
                        </div>
                        {dataCount > 0 && (
                            <div className="row">

                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                                    <div className="tg-sectionhead tg-textalignleft">
                                        <div className="tg-sectionheading">

                                            <h2>Speakers</h2>
                                        </div>
                                        <div className="tg-description">

                                        </div>
                                    </div>
                                </div>
                                <div id="tg-eventspeakerslider" className="tg-eventspeakerslider tg-speakers">
                                    {/* {JSON.stringify(sessionspeaker)} */}
                                    {sessionspeaker.map(speaker => (

                                        <div key={speaker.id} className="item tg-speaker col-md-3" style={{ height: "450px" }}>
                                            <figure className="tg-speakerimg">
                                                <Link target="_blank" to={`/speakerdetails/${speaker.speakerid}`}>
                                                    <img src={`${BACK_URL}/${speaker.image}`} alt="" /></Link>
                                            </figure>
                                            <div className="tg-contentbox" style={styles}>
                                                <div className="tg-title">
                                                    <Link target="_blank" to={`/speakerdetails/${speaker.speakerid}`}>       <h2>{speaker.speakername}</h2></Link>
                                                    <Link target="_blank" to={`/speakerdetails/${speaker.speakerid}`}>
                                                        <span>{speaker.title}</span>
                                                    </Link>
                                                    <span>{speaker.subtitle}</span>
                                                </div>
                                                <div className="tg-description">
                                                    <p className="designation">{speaker.designation}</p>
                                                </div>

                                            </div>
                                        </div>
                                    ))}


                                </div>


                            </div>
                        )}
                    </div>
                </section>

            </main >
        </>
    )
}
